export default __webpack_public_path__ + "static/media/contacto-gold-title.c450ee50.svg";